import { useState } from 'react';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useToast } from '../context/ToastContext';
import CrmLeadFormDialog from '../components/CrmLeadFormDialog';
import { PageHeader } from '../components/ui';

/**
 * Standalone create page for users with lead_requests_create but not Lead Requests view.
 */
const CreateManualLead = () => {
  const { showToast } = useToast();
  const [open, setOpen] = useState(true);

  return (
    <Box>
      <PageHeader
        title="Create manual lead"
        subtitle="Log an office visit or other manual lead. You won't see the full lead list."
        actions={
          <Button variant="contained" startIcon={<AddIcon />} onClick={() => setOpen(true)}>
            Create manual lead
          </Button>
        }
      />

      <Card>
        <CardContent>
          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
            Use the button above to open the lead form. After saving, you can create another lead the same way.
          </Typography>
        </CardContent>
      </Card>

      <CrmLeadFormDialog
        open={open}
        mode="create"
        onClose={() => setOpen(false)}
        onSaved={() => {
          setOpen(false);
          showToast({ message: 'Lead created.', severity: 'success' });
        }}
      />
    </Box>
  );
};

export default CreateManualLead;
